import { render } from "./CreateOfferPrice.vue?vue&type=template&id=3b1f8c70&scoped=true"
import script from "./CreateOfferPrice.vue?vue&type=script&lang=js"
export * from "./CreateOfferPrice.vue?vue&type=script&lang=js"

import "./CreateOfferPrice.vue?vue&type=style&index=0&id=3b1f8c70&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b1f8c70"]])

export default __exports__